import React, { useState, useEffect } from 'react';
import { getBienById } from '../../flux/actions/bienActions';
import { Container, Row, Col } from 'reactstrap';
import BienCard from './BienCardInfo';

import { connect } from 'react-redux';
import { IBienCardContainer, IBienCardReduxProps } from '../../types/interfaces';

import { useLocation, useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import LoadingPage from '../../pages/loading';

const BienCardContainerComponent = ({ 
  getBienById,
  bien
 }: IBienCardContainer) => {
  const history = useHistory();
  const alert = useAlert();
  const { info, loading } = bien;

  let { id } = useParams();

  useEffect(() => {
    if(id !== undefined && id !== null && !isNaN(id) && id >= 0)
      getBienById(id);
  }, []);

  return loading ? <LoadingPage/> : (
    <>
      <Container><h2 className="title">Fiche Bien</h2></Container>
      {info && <BienCard selectedBien={info} />}
    </>
  );
};

const mapStateToProps = (state: IBienCardReduxProps) => ({
  bien: state.bien,
  auth: state.auth
});

export default connect(mapStateToProps, { getBienById })(BienCardContainerComponent);
